<script>
    export let handleAction;

    let buttonClicked = false;
    let loading = false;

    async function actionClicked() {
        loading = true;
        await handleAction();
        loading = false;
    }
</script>

{#if buttonClicked === false}
    <button class="confirmation-button" on:click={() => (buttonClicked = true)}>
        <slot></slot>
    </button>
{:else}
    <div class="confirmation-modal">
        <p class="confirmation-modal__text">
            {loading ? "Updating..." : "Are you sure?"}
        </p>

        <div class="confirmation-modal__buttons">
            {#if loading}
                <svg
                    class="loading"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                    />
                </svg>
            {:else}
                <button
                    class="confirmation-modal__button"
                    on:click={() => (buttonClicked = false)}
                >
                    Cancel
                </button>

                <button
                    class="confirmation-modal__button confirmation-modal__button--confirm"
                    on:click={actionClicked}
                >
                    Confirm
                </button>
            {/if}
        </div>
    </div>
{/if}

<style>
    .confirmation-button {
        @apply reset flex items-center justify-center rounded-full bg-gray-400 px-4 py-2 text-center text-base text-white hover:bg-gray-500 !important;
    }

    .confirmation-modal {
        @apply flex flex-row items-center rounded-full border border-pink-200 bg-pink-100 pl-4 !important;
    }

    .confirmation-modal__text {
        @apply reset text-sm !important;
    }

    .confirmation-modal__buttons {
        @apply ml-auto flex select-none items-center justify-end p-2 !important;
    }

    .confirmation-modal__button {
        @apply reset rounded-sm border-none px-2 py-1 text-xs font-normal text-black no-underline hover:bg-pink-200 focus:outline-none !important;
    }

    .confirmation-modal__button--confirm {
        @apply font-bold text-pink-500 hover:bg-pink-200 !important;
    }

    .loading {
        @apply reset h-4 w-4 animate-spin text-pink-500 !important;
    }
</style>
